import XHR from 'jquery';
import AjaxAPI from '../components/base/ajax_api.js';

window.XHR = XHR;
window.AjaxAPI = AjaxAPI;
